var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a75b0eff419316df8a0d569085104911.js').default;export default
        Object.assign({}, scope_0 )
    